import {
  startRetryConnect,
  stopRetryConnect,
  setFailedApiUrl,
} from 'store/services/chat/actions';
import { setApiUrl } from '../services/chat/actions';
import { UrlSelectMethod } from 'types';

export const handleMultipleApiUrlError = (
  apiUrls,
  urlSelectMethod,
  store,
  ws,
) => {
  store.dispatch(setFailedApiUrl(ws._ws.url));

  if (ws.retryCount > apiUrls.length - 1) {
    store.dispatch(stopRetryConnect());
    store.dispatch(setApiUrl(apiUrls, urlSelectMethod));
  } else {
    store.dispatch(startRetryConnect());
  }
};

export const handleSingleApiUrlError = (store, ws) => {
  if (ws.retryCount > 5) {
    store.dispatch(stopRetryConnect());
  } else {
    store.dispatch(startRetryConnect());
  }
};

export const urlProvider = (
  store,
  apiUrls: string[],
  urlSelectMethod: UrlSelectMethod,
): Promise<string> => {
  return new Promise(resolve => {
    const { activeApiUrl } = store.getState().chat;
    store.subscribe(() => {
      const { chat } = store.getState();
      if (chat.activeApiUrl) {
        resolve(chat.activeApiUrl);
      }
    });

    if (!activeApiUrl) {
      store.dispatch(setApiUrl(apiUrls, urlSelectMethod));
    } else {
      resolve(activeApiUrl);
    }
  });
};
